import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import { usePreferences, } from "../context/PreferencesContext";
import { getAvaaioAuthCopy, interpolateAuthCopy, } from "../utils/avaaioAuthCopy";
export default function GlobalFooter({ compact = false, }) {
    const { preferences } = usePreferences();
    const copy = getAvaaioAuthCopy(preferences.language);
    const links = [
        {
            path: "/privacy-policy",
            label: copy.common.privacy,
        },
        {
            path: "/terms-and-conditions",
            label: copy.common.terms,
        },
        {
            path: "/ai-disclaimer",
            label: copy.common.aiDisclaimer,
        },
        {
            path: "/credits",
            label: copy.common.credits,
        },
        {
            path: "/support",
            label: copy.common.support,
        },
    ];
    return (_jsxs("footer", { className: `avaaio-global-footer${compact
            ? " avaaio-global-footer--compact"
            : ""}`, children: [_jsx("div", { className: "avaaio-global-footer__identity", children: copy.common.powered }), _jsx("div", { className: "avaaio-global-footer__copyright", children: interpolateAuthCopy(copy.common.copyright, {
                    year: new Date().getFullYear(),
                }) }), _jsx("nav", { className: "avaaio-global-footer__links", "aria-label": "AVAAIO legal and support links", children: links.map((link, index) => (_jsxs(React.Fragment, { children: [_jsx(Link, { to: link.path, children: link.label }), index < links.length - 1 ? (_jsx("span", { "aria-hidden": "true", className: "avaaio-global-footer__separator", children: "\u2022" })) : null] }, link.path))) })] }));
}
